import { isRegisteredProgramInvitee } from 'models';
import { Card } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { UserLink, UserPopover } from 'features/users/components';
import { useEventInviteesInfiniteQuery } from '../../../queries';
import { EventInviteeAvatar } from '../event-invitee-avatar';

type P = {
  eventId: string;
};

const EventAdmins = ({ eventId }: P) => {
  const { data: allInviteesData, isLoading } = useEventInviteesInfiniteQuery({
    filter: { eventId, role: 'moderator', status: 'going' },
    pagination: { pageSize: 10 },
  });

  const allAdmins = allInviteesData?.pages
    .flat()
    .flatMap((inviteesPaginated) => inviteesPaginated.data)
    .filter((invitee) => isRegisteredProgramInvitee(invitee));

  if (allAdmins?.length === 0) {
    return null;
  }

  return (
    <>
      {isLoading || !allAdmins ? (
        <Card.HorizontalScroll.EntitySkeleton />
      ) : (
        <Card.HorizontalScroll
          items={allAdmins.map((admin) => ({
            content: (
              <UserPopover popoverProps={{ stretch: true }} user={admin}>
                <UserLink userId={admin.id}>
                  <EventInviteeAvatar user={admin} />
                </UserLink>
              </UserPopover>
            ),
            key: admin.id,
          }))}
          title="Admins"
        />
      )}
    </>
  );
};

export default EventAdmins;
